import { render } from "./PostList.vue?vue&type=template&id=24f4a166&scoped=true&ts=true"
import script from "./PostList.vue?vue&type=script&lang=ts"
export * from "./PostList.vue?vue&type=script&lang=ts"

import "./PostList.vue?vue&type=style&index=0&id=24f4a166&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24f4a166"]])

export default __exports__